import { takeEvery, fork, all, takeLatest } from 'redux-saga/effects';
import {
    GET_SHIPPING_METHODS,
    GET_SHIP_TO_ADDRESS,
    GET_SURGERY_DETAILS,
    GET_DERIVED_TERRITORIES,
    UPDATE_EQUITY_DETAILS,
    updateDetailedEquityProductTemplateList,
} from '../actions';

import {
    GET_DROPDOWN,
    GET_PRODUCTS,
    GET_PRODUCTS_BULK,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    CREATE_PRODUCT_TEMPLATE,
    GET_TEMPLATE_DETAILS,
    UPDATE_PRODUCT_TEMPLATE,
    GET_DATA_FOR_PRODUCT_TEMPLATE,
    GET_EQUITY_DETAILS,
    SAVE_EQUITY_DETAILS,
    VALIDATE_ACCOUNT,
    VALIDATE_PRODUCTS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    GET_PRODUCT_DETAILS,
    GET_PRODUCTSGUIDE,
    GET_PRICES_FOR_ITEMS,
    EQUITY_USAGE_ATTACHMENT_UPLOAD,
    EQUITY_DELETE_ATTACHMENT_REQUEST,
    EQUITY_GET_IMAGE_PO_PREVIEW,
    EQUITY_ORDER_FROM_USAGE_DETAILS,
    GET_DROPDOWN_OPTIONS,
    UPDATE_PRODUCT_TEMPLATE_LIST,
    GET_PRODUCT_BUNDLE,
} from '../actions/actionTypes';
import equitySearchProducts from './productsSearchSaga';
import equitySearchProductsBulk from './productsSearchBulkSaga';
import getEquityDropDownSaga from './getDropDownSaga';
import getEquityProductGuideSaga from './productsGuideSaga';
import validateProductsSaga from './validateProductsSaga';
//import productsTemplatesFilterSaga from './productsTemplatesFilterSaga';
import getShippingMethodsSaga from './shippingMethodsSaga';
import getShipToAddressSaga from './shipToAddressSaga';
import getProductDetailsSaga from './productDetailsSaga';
import getSurgeryDetailsSaga from './surgeryDetailsSaga';
import updateEquitySaga from './updateEquitySaga';
import getEquityCategoryAndBrands from './getEquityCategoryAndBrandsSaga';
import getEquityProductsByBrandOrSuperCategory from './getEquityProductsByBrandOrSuperCategorySaga';
import getDerivedTerritories from './derivedTerritorySaga';
import {
    createEquityProductTemplate,
    getDetailedEquityProductTemplates,
    getEquityTemplateDetails,
    updateEquityProductTemplate,
    getDataForEquityTemplate,
} from './productTemplateSaga';
import {
    getEquityDetailsSaga,
    usageAttachmentUploadSaga,
    deleteAttachmentSaga,
    getImagePoPreviewSaga,
} from './getEquityDetailsSaga';
import saveEquity from './createEquitySaga';
import validateAccountSaga from './validateAccountSaga';
import getPricesForEquityItemsSaga from './getPricesForItemsSaga';
import equityOrderFromUsageDetails from './equityOrderFromUsageSaga';
import equityPriceOverrideSaga from './equityPriceOverrideSaga';
import equitySearchProductsBundle from './productSearchBundleSaga';

function* watchEquityGetDropDownSaga() {
    yield takeEvery(GET_DROPDOWN, getEquityDropDownSaga);
}

function* watchGetEquityProductsSaga() {
    yield takeEvery(GET_PRODUCTS, equitySearchProducts);
}

function* watchGetEquityProductsBulkSaga() {
    yield takeEvery(GET_PRODUCTS_BULK, equitySearchProductsBulk);
}

function* watchGetEquityProductsGuideSaga() {
    yield takeEvery(GET_PRODUCTSGUIDE, getEquityProductGuideSaga);
}

// function* watchGetProductsTemplatesFilterSaga() {
//     yield takeEvery(GET_PRODUCTSTEMPLATESFILTER, productsTemplatesFilterSaga);
// }

function* watchValidateEquityProductsSaga() {
    yield takeEvery(VALIDATE_PRODUCTS, validateProductsSaga);
}

function* watchGetProductDetailsSaga() {
    yield takeEvery(GET_PRODUCT_DETAILS, getProductDetailsSaga);
}

function* watchGetShipToAddressSaga() {
    yield takeEvery(GET_SHIP_TO_ADDRESS, getShipToAddressSaga);
}

function* watchGetShippingMethodsSaga() {
    yield takeEvery(GET_SHIPPING_METHODS, getShippingMethodsSaga);
}

function* watchSurgeryDetailsSaga() {
    yield takeLatest(GET_SURGERY_DETAILS, getSurgeryDetailsSaga);
}

function* watchUpdateEquitySaga() {
    yield takeLatest(UPDATE_EQUITY_DETAILS, updateEquitySaga);
}

function* watchGetEquityCategoryAndBrandsSaga() {
    yield takeLatest(
        GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
        getEquityCategoryAndBrands
    );
}

function* watchGetEquityProductsByBrandOrSuperCategorySaga() {
    yield takeLatest(
        GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        getEquityProductsByBrandOrSuperCategory
    );
}

function* watchGetDerivedTerritoriesSaga() {
    yield takeLatest(GET_DERIVED_TERRITORIES, getDerivedTerritories);
}

function* watchGetDetailedEquityProductTemplatesSaga() {
    yield takeLatest(
        GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        getDetailedEquityProductTemplates
    );
}

function* watchGetEquityProductTemplateDetailsSaga() {
    yield takeLatest(GET_TEMPLATE_DETAILS, getEquityTemplateDetails);
}

function* watchCreateEquityProductTemplateSaga() {
    yield takeLatest(CREATE_PRODUCT_TEMPLATE, createEquityProductTemplate);
}

function* watchUpdateEquityProductTemplateSaga() {
    yield takeLatest(UPDATE_PRODUCT_TEMPLATE, updateEquityProductTemplate);
}

function* watchGetDataForEquityProductTemplateSaga() {
    yield takeLatest(GET_DATA_FOR_PRODUCT_TEMPLATE, getDataForEquityTemplate);
}

function* watchUpdateDetailedEquityProductTemplatesSaga() {
    yield takeLatest(
        UPDATE_PRODUCT_TEMPLATE_LIST,
        updateDetailedEquityProductTemplateList
    );
}

function* watchGetEquityDetailsSaga() {
    yield takeLatest(GET_EQUITY_DETAILS, getEquityDetailsSaga);
}

function* watchSaveEquitySaga() {
    yield takeLatest(SAVE_EQUITY_DETAILS, saveEquity);
}

function* watchValidateAccountSaga() {
    yield takeLatest(VALIDATE_ACCOUNT, validateAccountSaga);
}

function* watchGetPricesForEquityItemsSaga() {
    yield takeEvery(GET_PRICES_FOR_ITEMS, getPricesForEquityItemsSaga);
}
function* watchUsageUploadAttcahmentSaga() {
    yield takeLatest(EQUITY_USAGE_ATTACHMENT_UPLOAD, usageAttachmentUploadSaga);
}
function* watchUsageDeleteAttcahmentSaga() {
    yield takeLatest(EQUITY_DELETE_ATTACHMENT_REQUEST, deleteAttachmentSaga);
}
function* watchGetImagePOPreviewSaga() {
    yield takeLatest(EQUITY_GET_IMAGE_PO_PREVIEW, getImagePoPreviewSaga);
}
function* watchEquityOrderFromUsageSaga() {
    yield takeLatest(
        EQUITY_ORDER_FROM_USAGE_DETAILS,
        equityOrderFromUsageDetails
    );
}

function* watchEquityPriceOverrideSaga() {
    yield takeLatest(GET_DROPDOWN_OPTIONS, equityPriceOverrideSaga);
}

function* watchGetEquityProductsBundleSaga() {
    yield takeEvery(GET_PRODUCT_BUNDLE, equitySearchProductsBundle);
}

export default function* equityRootSaga() {
    yield all([
        fork(watchEquityGetDropDownSaga),
        fork(watchGetEquityProductsGuideSaga),
        //fork(watchGetProductsTemplatesFilterSaga),
        fork(watchGetEquityProductsSaga),
        fork(watchGetEquityProductsBulkSaga),
        fork(watchGetProductDetailsSaga),
        fork(watchValidateEquityProductsSaga),
        // fork(watchGetProductDetailsSaga),
        fork(watchGetShippingMethodsSaga),
        fork(watchGetShipToAddressSaga),
        // fork(watchGetShippingBatchLocationsSaga),
        // fork(watchSaveSurgerySaga),
        fork(watchSurgeryDetailsSaga),
        fork(watchUpdateEquitySaga),
        fork(watchGetEquityCategoryAndBrandsSaga),
        fork(watchGetEquityProductsByBrandOrSuperCategorySaga),
        // fork(watchPutRecentlyUsedPhysicianSaga),
        fork(watchGetDerivedTerritoriesSaga),
        fork(watchGetDetailedEquityProductTemplatesSaga),
        fork(watchCreateEquityProductTemplateSaga),
        fork(watchGetEquityProductTemplateDetailsSaga),
        fork(watchUpdateEquityProductTemplateSaga),
        // fork(getHolidayListSaga),
        fork(watchGetDataForEquityProductTemplateSaga),
        fork(watchGetEquityDetailsSaga),
        fork(watchSaveEquitySaga),
        fork(watchValidateAccountSaga),
        fork(watchGetPricesForEquityItemsSaga),
        fork(watchUsageUploadAttcahmentSaga),
        fork(watchUsageDeleteAttcahmentSaga),
        fork(watchGetImagePOPreviewSaga),
        fork(watchEquityOrderFromUsageSaga),
        fork(watchEquityPriceOverrideSaga),
        fork(watchUpdateDetailedEquityProductTemplatesSaga),
        fork(watchGetEquityProductsBundleSaga),
    ]);
}
